import React, { Component } from 'react';
import language from '../../assets/languages/language';
import ModalComponent from '../Common/Modal';
import AlertMessage from '../config/alertMessage';
const pStyle = {
  fontSize: '15px',
  color: 'red',
};

class CommonFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBy: this.props.searchBy === 'questionID' ? 'questionID' : 'chapterID',
      answered: 'false',
      filterBy: '',
      selectedChapter: this.props.selectedChapter,
      showError: false,
      showErrorNumber: false,
      subscriptionstatus: this.props.subscriptionstatus,
      MessageContent: AlertMessage.messageContent_cfa_1,
      alert_status: false,
      selectedmenu: 'cfa',
    };
  }

  static contextTypes = { router: React.PropTypes.object };

  toggleAlert = () => {
    this.setState({ alert_status: !this.state.alert_status });
  };

  goPremium = () => {
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: storage_session['token'],
        idname: storage_session['idname'],
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  searchByQuestionID() {
    if (this.props.subscriptionstatus === 'free') {
      this.toggleAlert();
    } else {
      this.setState({
        filterBy: '',
        answered: 'false',
        searchBy: 'questionID',
        showError: false,
      });
      this.props.resetAllQuestion();
    }
  }

  searchByChapterID() {
    this.setState({
      answered: 'false',
      searchBy: 'chapterID',
      showError: false,
      filterBy: '',
    });
    this.props.resetAllChapter();
  }

  onChangeQuestion(e) {
    const ageValue = e.target.value;
    if (isNaN(ageValue) || ageValue < 0) {
      return;
    } else {
      this.setState({ selectedChapter: e.target.value, showError: false });
      this.props.onChangeQuestion(e);
    }
  }

  onChangeChapter(e) {
    console.log('e.target', e.target);
    this.setState({ selectedChapter: e.target.value, showError: false });
    this.props.onChangeChapter(e);
  }

  onChangeReading(e) {
    this.props.onChangeReading(e);
  }

  onChangeAnswered(e) {
    // console.log(e.target.value)
    if (e.target.value === this.state.answered) {
      this.props.onChangeAnswered(e);
    } else {
      this.setState({ answered: e.target.value });
      this.props.onChangeAnswered(e);
    }
  }

  onChangeNoOfAttempts(e) {
    this.props.onChangeNoOfAttempts(e);
  }

  onChangeAvgScore(e) {
    // console.log(e);
    this.props.onChangeAvgScore(e);
  }

  onChangePass(e) {
    if (e.target.value === 'FAIL') {
      this.setState({ filterBy: 'FAIL' });
      this.props.onChangePass(e);
    } else if (e.target.value === 'PASS') {
      this.setState({ filterBy: 'PASS' });
      this.props.onChangePass(e);
    } else {
      this.setState({ filterBy: '' });
      this.props.onChangePass(e);
    }
  }

  componentDidMount() {
    // console.log(this.props.selectedChapter)
    this.setState({
      selectedChapter: this.props.selectedChapter,
      subscriptionstatus: this.props.subscriptionstatus,
    });
  }

  componentDidUpdate(prepProps, prevState) {
    if (prepProps.selectedChapter !== this.state.selectedChapter) {
      // console.log(this.props.selectedChapter)
      this.setState({
        selectedChapter: this.props.selectedChapter,
        subscriptionstatus: this.props.subscriptionstatus,
      });
    }
  }

  filerSubmitFun(e) {
    e.preventDefault();
    // console.log(this.state.selectedChapter)
    // console.log(this.props.selectedChapter)
    if (this.props.subscriptionstatus === 'free') {
      this.toggleAlert();
    } else {
      if (this.state.selectedChapter === '' && this.state.searchBy === 'chapterID') {
        this.setState({ showError: true });
      } else {
        this.setState({ showError: false });
        this.props.filerSubmit(e);
      }
    }
  }

  resetAll(e) {
    e.preventDefault();
    this.setState({ showError: false, answered: 'false' });
    if (this.state.searchBy === 'questionID') {
      this.props.resetAllQuestion(e);
    } else if (this.state.searchBy === 'chapterID') {
      this.props.resetAllChapter(e);
    }
  }

  render() {
    // console.log(this.props.searchBy)
    // console.log(this.state.searchBy)
    // console.log(this.props.selectedChapter)
    // console.log(this.state.selectedChapter)
    // console.log(this.state.subscriptionstatus);
    const { readingData } = this.props;
    const { chapterData } = this.props;
    // const { subscriptionstatus }=this.props
    const { searchBy } = this.state;
    // console.log("chapterData");
    // console.log(chapterData);
    return (
      <div className=''>
        <div className='filter-toggle-btn'>
          <p> {language.LC().Filter_By} -</p>
          <ul className='filter-subnav'>
            <li
              onClick={this.searchByQuestionID.bind(this)}
              className={searchBy === 'questionID' ? 'active' : ''}
            >
              <span> {language.LC().QUESTION_ID} </span>
            </li>
            <li
              onClick={this.searchByChapterID.bind(this)}
              className={searchBy === 'chapterID' ? 'active' : ''}
            >
              <span> {language.LC().CHAPTER} </span>
            </li>
          </ul>
        </div>

        <div>
          {' '}
          {this.state.showErrorNumber ? (
            <label style={pStyle}> *{language.LC().Please_Enter_Number_Only} </label>
          ) : null}{' '}
        </div>
        <div>
          {' '}
          {this.state.showError ? (
            <label style={pStyle}> *{language.LC().Please_select_Chapter_ID} </label>
          ) : null}{' '}
        </div>
        <div className='filter-head-wrapper question-list-filter-search'>
          {this.state.searchBy === 'questionID' ? (
            <div className='question-filter-search-wrap'>
              <div className='form-group'>
                <label> {language.LC().Question_ID} </label>
                <input
                  type='text'
                  min='1'
                  onChange={this.onChangeQuestion.bind(this)}
                  className='form-control form-control'
                  value={this.props.selectedQuestion}
                />
              </div>
            </div>
          ) : (
            <div className='chapter-filter-search-wrap'>
              <div className='chapter-fitler-search-block'>
                <div className='form-group'>
                  <label> {language.LC().Chapter_Name} </label>
                  <select
                    name='category_id'
                    onChange={this.onChangeChapter.bind(this)}
                    className='form-control form-control'
                    value={this.props.selectedChapter}
                  >
                    <option value=''> {language.LC().SELECT} </option>
                    {chapterData && chapterData.length ? (
                      chapterData.map((item, index) => {
                        return (
                          <option key={index} value={item.chapterId}>
                            {' '}
                            {item.chapterName}{' '}
                          </option>
                        );
                      })
                    ) : (
                      <option>--</option>
                    )}
                  </select>
                </div>

                <div className='form-group'>
                  <label> {language.LC().Reading_Name} </label>
                  <select
                    name='category_id'
                    onChange={this.onChangeReading.bind(this)}
                    className='form-control form-control'
                    value={this.props.selectedReading}
                  >
                    <option value=''> {language.LC().SELECT} </option>
                    {readingData && readingData.length ? (
                      readingData.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {' '}
                            {item.reading}{' '}
                          </option>
                        );
                      })
                    ) : (
                      <option>--</option>
                    )}
                  </select>
                </div>
                <div className='form-group'>
                  <label>{language.LC().ANSWERED}</label>
                  <select
                    name='category_id'
                    onChange={this.onChangeAnswered.bind(this)}
                    className='form-control form-control'
                    value={this.props.Answered}
                  >
                    <option value=''>{language.LC().SELECT} </option>
                    <option value='true'>{language.LC().ANSWERED}</option>
                    <option value='false'> {language.LC().Non_ANSWERED} </option>
                  </select>
                </div>
              </div>
              {this.state.answered === 'true' ? (
                <div className='chapter-fitler-search-block select-search'>
                  <div className='form-group'>
                    <label> {language.LC().No_of_attempts} </label>
                    <select
                      name='category_id'
                      onChange={this.onChangeNoOfAttempts.bind(this)}
                      className='form-control form-control'
                      value={this.props.selectedAttempt}
                    >
                      <option value=''> {language.LC().SELECT} </option>
                      <option value='1'>1</option>
                      <option value='2'>2</option>
                      <option value='3'>3</option>
                      <option value='4'>4</option>
                      <option value='5'>5</option>
                      <option value='6'>6</option>
                      <option value='7'>7</option>
                      <option value='8'>8</option>
                      <option value='9'>9+</option>
                    </select>
                  </div>

                  <div className='form-group'>
                    <label> {language.LC().AVERAGE_SCORE} </label>
                    <select
                      name='category_id'
                      onChange={this.onChangeAvgScore.bind(this)}
                      className='form-control form-control'
                      value={this.props.selectedAvgScore}
                    >
                      <option value=''> {language.LC().SELECT} </option>
                      {this.state.filterBy === '' ? (
                        <option value='0'> 0 - 25</option>
                      ) : this.state.filterBy === 'FAIL' ? (
                        <option value='0'> 0 - 25</option>
                      ) : null}
                      {this.state.filterBy === '' ? (
                        <option value='1'> 25 - 50</option>
                      ) : this.state.filterBy === 'FAIL' ? (
                        <option value='1'> 25 - 50</option>
                      ) : null}
                      {this.state.filterBy === '' ? (
                        <option value='2'> 50 - 75</option>
                      ) : this.state.filterBy === 'FAIL' ? (
                        <option value='2'> 50 - 70</option>
                      ) : null}
                      {this.state.filterBy === '' ? (
                        <option value='3'> 75 - 100</option>
                      ) : this.state.filterBy === 'PASS' ? (
                        <option value='3'> 70 - 100</option>
                      ) : null}
                    </select>
                  </div>

                  {/* <div className="form-group">
        <label> {language.LC().Passing_Score}  </label>
        <select
          name="category_id"
          onChange={this.onChangePass.bind(this)}
          className="form-control form-control"
          value={this.props.selectedPassingScore}
        >
          <option value=""> {language.LC().SELECT} </option>
          <option value="PASS"> {language.LC().NO} </option>
          <option value="FAIL"> {language.LC().YES} </option>
        </select>
            </div>  */}
                </div>
              ) : null}
            </div>
          )}

          <div className='form-group apply-filter-btn'>
            <button
              className='btn btn-primary'
              value={this.state.selectedQuestion}
              onClick={this.filerSubmitFun.bind(this)}
            >
              <i className='fa fa-search' />
            </button>
            <button className='btn btn-danger' onClick={this.resetAll.bind(this)}>
              <i className='fa fa-refresh' aria-hidden='true' />
            </button>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
      </div>
    );
  }
}

export default CommonFilter;



// WEBPACK FOOTER //
// ./src/views/Common/CommonFilter.js